<template>
  <div class="shopsolcoffee-container">
    <!-- Cricle box -->
    <a class="circle-box" v-if="isShowFloating" tabindex="0" @click="goDownloadApp">
      <img src="/media/img/event/shopsol_appdownloadbtn.png" alt="앱다운로드" />
    </a>
    <!-- shopsol bannerl1 -->
    <div class="shopsolcoffee-banner1" ref="shopsolsection1">
      <img class="shopsolcoffee-banner1-img" src="/media/img/event/apzrecommend_bannerimg1_.png" />
    </div>

    <!-- shopsol banner2 -->
    <div class="shopsolcoffee-banner2">
      <a href="http://pf.kakao.com/_xexcxmnxj" target="_blank" @click="onClickKakao">
        <img src="/media/img/event/apz_kakao_btn.png" />
      </a>
      <img class="shopsolcoffee-banner1-img" src="/media/img/event/apzrecommend_bannerimg2_.png" />
    </div>

    <!-- shopsol banner3-->
    <div class="shopsolcoffee-banner3">
      <img class="shopsolcoffee-banner1-img" src="/media/img/event/apzrecommend_bannerimg3__.jpg" />
    </div>
  </div>
</template>
<script>
import { getMobileOS } from '@/utils/Utils';

export default {
  mounted() {
    window.addEventListener('scroll', this.scrollEvent);
  },
  data() {
    return {
      isShowFloating: false
    };
  },
  methods: {
    scrollEvent() {
      const scrollY = window.scrollY;
      const { clientHeight } = this.$refs.shopsolsection1;
      if (scrollY > clientHeight) {
        this.isShowFloating = true;
      } else {
        this.isShowFloating = false;
      }
    },
    goPlayStore() {
      this.$gatag.event('web_apzrecommend_googleplay_click');
      window.open(`https://play.google.com/store/apps/details?id=com.mobileaos.aplayz`, '_blank');
    },
    goAppleStore() {
      this.$gatag.event('web_apzrecommend_applestore_click');
      window.open(`https://apps.apple.com/kr/app/aplayz/id6446978790`, '_blank');
    },
    goDownloadApp() {
      const os = getMobileOS();
      this.$gatag.event('web_apzrecommend_appdownload_click');
      if (os === 'Android' || os === 'Other') {
        this.goPlayStore();
      } else if (os === 'iOS') {
        this.goAppleStore();
      }
    },
    onClickKakao() {
      this.$gatag.event('web_apzrecommend_kakaofriend');
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollEvent);
  }
};
</script>
<style scoped src="@/assets/css/shopsolcoffeevent/shopsolcoffeevent.css"></style>
